import React, { useState, useEffect, FC, useLayoutEffect } from 'react';
import _ from 'lodash';
import queryString from 'query-string';

import { getTierRequested } from '../redux/reducers/tier.slice';
import { getProjectRequested } from '../redux/reducers/project.slice';

import { useMetaMask } from '../context/MetaMaskContext';
import Header from '../components/Header';
import { ethers } from 'ethers';
import MyToken1155Artifacts from '../artifacts/contracts/MyToken1155.sol/MyToken1155.json';
import { MyToken1155 } from '../@types/contracts/MyToken1155';
import { useAppSelector, useAppDispatch } from '../redux/hooks';
import { useParams } from 'react-router-dom';
import ModalPurchaseNFT from '../components/ModalPurchaseNFT';
import ModalJoinCrewMember from '../components/ModalJoinCrewMember';
import toast from 'react-hot-toast';
import { setTimeout } from 'timers';
import { ReactComponent as BuySVG } from '../svg/buy.svg';

type FundingProps = {};

const Funding: FC<FundingProps> = () => {
  const { metaMask } = useMetaMask();
  const dispatch = useAppDispatch();

  const query = queryString.parse(location.search);
  let { id: projectId } = useParams<{ id: string }>();

  const tiers = useAppSelector((state) => state.tier.value);
  const project = useAppSelector((state) => state.project.current);
  const [crewMembers, setCrewMembers] = useState<CrewMember[] | undefined>(project?.crewMembers);
  const [backers, setBackers] = useState<Backer[]>([]);
  const [isOpenPurchase, setIsOpenPurchase] = useState(false);
  const [isOpenJoinCrewMember, setIsOpenJoinCrewMember] = useState(false);
  const [fundingPercentage, setFundingPercentage] = useState<number>(0);
  const [selectedNFTIndex, setSelectedNFTIndex] = useState<number>(-1);
  const [numberOfBackerIsShowing, setNumberOfBackerIsShowing] = useState<number>(5);
  const [tiersToPurchase, setTiersToPurchase] = useState<Tier[]>([]);

  function toggleModalPurchase() {
    setIsOpenPurchase((prev) => !prev);
  }

  function toggleModalJoinCrewMember() {
    setIsOpenJoinCrewMember((prev) => !prev);
  }

  useEffect(() => {
    if (!metaMask.isConnected || !metaMask.addressNFT1155) {
      return;
    }
    let timer: NodeJS.Timeout;

    const provider = new ethers.providers.Web3Provider(metaMask.provider);
    const contract = new ethers.Contract(metaMask.addressNFT1155, MyToken1155Artifacts.abi, provider) as MyToken1155;

    contract.on('purchaseNFT', (backerAddress, purchaseItems) => {
      console.log(backerAddress, purchaseItems);

      timer = setTimeout(() => {
        toast.success('Purchase NFT successfully.');
        dispatch(getProjectRequested({ id: +projectId }));
        dispatch(getTierRequested({ projectId: +projectId }));
      }, 3000);
    });

    return () => {
      clearTimeout(timer);
      contract.removeAllListeners('purchaseNFT');
    };
  }, [metaMask]);

  useLayoutEffect(() => {
    if (!projectId) return;

    dispatch(getProjectRequested({ id: +projectId }));
    dispatch(getTierRequested({ projectId: +projectId }));
  }, [projectId]);

  useLayoutEffect(() => {
    if (metaMask.account && query.role_name && query.crew_id) {
      setIsOpenJoinCrewMember(true);
    }
  }, [metaMask]);

  useLayoutEffect(() => {
    if (tiers?.length === 0) return;

    setFundingPercentage(
      (tiers.reduce((s, i) => s + (Number(i.purchaseAmount) || 0), 0) * 100) /
        tiers.reduce((s, i) => s + Number(i.quantity), 0),
    );
  }, [tiers]);

  useLayoutEffect(() => {
    if (tiers?.length === 0) return;

    if (selectedNFTIndex === -1) {
      setTiersToPurchase(tiers);
    } else {
      const newTiers = tiers.filter((_, index) => index === selectedNFTIndex);
      setTiersToPurchase(newTiers);
    }
  }, [selectedNFTIndex, tiers]);

  useLayoutEffect(() => {
    if (!project) return;

    const grouped = _.groupBy(project.backers, (item) => item.userId);

    const modifiedBacker = [];

    for (const [, value] of Object.entries(grouped)) {
      const item = _.cloneDeep(value[0]);
      item.totalAmount = 0;
      for (const i of value) {
        item.totalAmount += i.amount;
      }
      modifiedBacker.push(item);
    }

    setBackers(modifiedBacker);
    setCrewMembers(project.crewMembers);
  }, [project]);

  const handleOpenPurchaseModal = () => {
    if (!metaMask.isConnected) {
      toast('Connect your wallet to start');
      return;
    }

    setIsOpenPurchase(true);
  };

  return (
    <>
      <Header />

      <div className="screen-container">
        <div className="img-background">
          <img src="../../images/project_background_left.png" alt="" />
          <img src="../../images/project_background.jpg" alt="" />
          <img src="../../images/project_background_right.png" alt="" />
        </div>

        <div className="gradient-background">
          <div></div>
          <div></div>
        </div>

        {project && (
          <div className="funding">
            <div className="funding-container">
              <div className="project-info">
                <img
                  width="260px"
                  height="386px"
                  src={`https://xyz-project-bucket.s3.us-west-2.amazonaws.com/${project?.fileName}`}
                />
                <div className="project-info--detail">
                  <h3>{project?.name}</h3>
                  <div className="description">{project?.description}</div>
                  {project?.type === 'classic' && (
                    <div>
                      <div className="crew-tile">Film crew:</div>
                      <div className="crew-info-only-view">
                        <div className="crew-info-only-view--body">
                          <div className="crew-member">
                            {crewMembers?.map((item, index) => (
                              <div key={index} className="crew-member--item">
                                <div className="crew-member--item-name">
                                  <span>{item.roleName}:</span>
                                </div>
                                <div className="crew-member--item-percentage">
                                  <span>{item.percentage}%</span>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="project-funding">
                <div className="project-funding--percentage">
                  {project?.type === 'funding' && (
                    <div
                      style={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <span>Funding {fundingPercentage.toFixed(2)}%</span>
                    </div>
                  )}
                  {project?.type === 'funding' && tiers?.length !== 0 && (
                    <button
                      className="app-btn color-primary"
                      onClick={() => {
                        setSelectedNFTIndex(-1);
                        handleOpenPurchaseModal();
                      }}
                    >
                      Fund this project
                    </button>
                  )}
                </div>

                <div>
                  {tiers.map(
                    (item, index) =>
                      item?.published && (
                        <div key={index}>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                              <div style={{ flex: 1 }}>
                                {item.name} ({item.purchaseAmount}/{item.quantity} tokens)
                              </div>
                              <span
                                className="buy-icon"
                                onClick={() => {
                                  setSelectedNFTIndex(index);
                                  handleOpenPurchaseModal();
                                }}
                              >
                                <BuySVG />
                              </span>
                            </div>
                            <meter max={item.quantity} value={item.purchaseAmount} className="meter-item"></meter>
                          </div>
                        </div>
                      ),
                  )}
                </div>
              </div>

              <div className="project-backers">
                <div style={{ fontSize: 24 }}>Recent transactions</div>

                <div className="title">
                  <div
                    style={{
                      flex: 1,
                    }}
                  >
                    <h5>Backers</h5>
                  </div>
                  <div>
                    <h5># of tokens</h5>
                  </div>
                </div>

                {backers?.length > 0 ? (
                  <div>
                    {backers?.map(
                      (item, index) =>
                        index < numberOfBackerIsShowing && (
                          <div key={index} className="backer-item">
                            <div>{item.user.walletAddress}</div>
                            <div className="backer-amount">{item.totalAmount}</div>
                          </div>
                        ),
                    )}
                  </div>
                ) : (
                  <span
                    style={{
                      textAlign: 'center',
                      opacity: 0.5,
                    }}
                  >
                    Be our first backer
                  </span>
                )}

                {numberOfBackerIsShowing < backers.length && (
                  <div className="view-more">
                    <span onClick={() => setNumberOfBackerIsShowing(backers.length)}>view more</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {isOpenPurchase && (
        <ModalPurchaseNFT
          isOpen={isOpenPurchase}
          toggle={toggleModalPurchase}
          tiers={tiersToPurchase}
          selectedNFTIndex={selectedNFTIndex}
        />
      )}

      <ModalJoinCrewMember isOpen={isOpenJoinCrewMember} toggle={toggleModalJoinCrewMember} query={query} />
    </>
  );
};

export default Funding;
